import { useTranslation } from 'react-i18next';
import {
  Headings,
  ModalOverlay,
  SentaraLogo,
  MDLiveLogo,
  VirtualIcon,
  Loader
} from '@sentara-health/optimahealth_web';
import { VirtualVisitModalBox } from 'templates'; 
import {  navigateToExternalUrl, SuperScript} from 'common';
import { useContext } from 'react';
import { useVirtualPopUpHooks } from './hooks/VirtualPopUpHooks';
import { GlobalContext } from 'context';

interface PrimaryCarePopUpProps {
  closeModal: () => void;
  mdliveCopay?: string;
  sentaraCopay?: string;
}
function PrimaryCarePopUp({
    closeModal,
    mdliveCopay,
    sentaraCopay
}: Readonly<PrimaryCarePopUpProps>) {
    // Initialize translation hook
    const { t } = useTranslation();
    const { ssoEndPoints } = useContext(GlobalContext);

    const sentaraDisclaimerList = [
      {superScript: <sup>{SuperScript.VIRTUAL_DISCLAIMER_ONE}</sup>, text:t('virtualVisitCare.disclaimerNote2Common') , style:'mt-3'},
      {superScript: <sup>{SuperScript.VIRTUAL_DISCLAIMER_TWO}</sup>, text:t('virtualVisitCare.disclaimerNote1Common') , style:'mt-2'},
    ]

    const mdLiveDisclaimerList = [
        {superScript: <sup>{SuperScript.VIRTUAL_DISCLAIMER_TWO}</sup>, text:t('virtualVisitCare.disclaimerNote1Common') , style:'mt-3'}
      ]

    const primaryCarePopUpHooks = useVirtualPopUpHooks();  

  
    return (
      <>
        <ModalOverlay
          className="virtual-visit-selection"
          data-testid={'primaryCareSelectionId'}
          isOpen
          onClose={closeModal}
          overlayInfo="primary care selection"
        >
          <div>
          <Headings
            level={2}
            text={t('virtualVisitCare.selectProvider')}
            variant="regular"
            />
          <div className="d-flex flex-column flex-lg-row gap-4 mt-2 justify-content-center">
            <div className="curved-box">
              <VirtualVisitModalBox
                logoImage={<SentaraLogo/>}
                title={t(
                  'virtualVisitCare.sentaraHealthTitle'
                )}
                costValue={sentaraCopay}
                superTextOne={SuperScript.VIRTUAL_DISCLAIMER_ONE}
                superTextTwo={SuperScript.VIRTUAL_DISCLAIMER_TWO}
                costInfo={t('virtualVisitCare.costInfo')}
                badgeImage={<VirtualIcon/>}
                content={t(
                  'virtualVisitCare.PrimaryCare.sentaraContent.serviceContent'
                )}
                buttonLabel={t(
                  'virtualVisitCare.scheduleAppointment'
                )}
                buttonTestId='scheduleSentaraAppointment'
                buttonOnClick={() => {
                  navigateToExternalUrl(ssoEndPoints?.PRIMARY_CARE_URL); // Navigate to the URL
                }}
                minHeight={'260'}
                disclaimers={sentaraDisclaimerList}
                deductibleBlock={true}
                deductibleText= {t('virtualVisitCare.deductibleNote')}
              />
            </div>
            <div className=" curved-box">
              <VirtualVisitModalBox
                logoImage={<MDLiveLogo/>}
                title={t('virtualVisitCare.mdliveTitle')}
                costInfo={t('virtualVisitCare.costInfo')}
                badgeImage={<VirtualIcon/>}
                content={t(
                  'virtualVisitCare.serviceContent'
                )}
                costValue={mdliveCopay}
                superTextTwo={SuperScript.VIRTUAL_DISCLAIMER_TWO}
                buttonLabel={t(
                  'virtualVisitCare.scheduleAppointment'
                )}
                buttonTestId='scheduleMDliveAppointment'
                buttonOnClick={() => {
                  primaryCarePopUpHooks.getMDliveSSOUrlFromAPI(ssoEndPoints?.VirtualVisitSSO);
                }}
                minHeight={'260'}
                disclaimers={mdLiveDisclaimerList}
                deductibleBlock={true}
                deductibleText= {t('virtualVisitCare.deductibleNote')}
              /> 
            </div>
          </div>
        </div>
        </ModalOverlay>
        {primaryCarePopUpHooks.loading ? <Loader /> : null}
      </>
    );
  }
  
export default PrimaryCarePopUp;